import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { usePermissions } from '../utils/permissions';
import { useAuthStore } from '../store/useAuthStore';

/**
 * Route protector based on permissions.
 * 
 * @param {Object} props
 * @param {string|string[]} props.permission - Permission required to access the route.
 */
const PermissionRoute = ({ permission }) => {
  const { can } = usePermissions();
  const { token } = useAuthStore();

  // If not logged in, redirect to login
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // If lacks permission, redirect to dashboard
  if (!can(permission)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};

export default PermissionRoute;
